const getters = {
  isLoggedIn: state => state.auth.isLoggedIn
}
export default getters
